// Klik Academy Grid: category filter tags show/hide cards client-side. Also binds Fancybox for each
// card's video trigger (shared mechanics in filterGrid.js).
import initFilterGrid from './filterGrid';

export default function initAcademyGrid() {
  initFilterGrid({
    rootSelector: '.section-academy-grid',
    tagSelector: '.section-academy-grid__filter-tag',
    itemSelector: '.section-academy-grid__card',
    moreSelector: '.section-academy-grid__more',
    emptyText: (label) => 'No lessons under \u201C' + label + '\u201D yet \u2014 class is still in session. Try another category.',
    afterInit: () => {
      if (window.Fancybox) {
        window.Fancybox.bind('[data-fancybox="academy-videos"]', {});
      }
    },
  });
}
